import React from "react";
import VideoComponent from "../util/VideoComponent";

const VideosComponent = (props) => {
    return (
        <div>

            <VideoComponent id="S16V242" src={process.env.PUBLIC_URL + `/videos/S16V242.mp4`}/>
            <VideoComponent id="C01V305" src={process.env.PUBLIC_URL + `/videos/C01V305.mp4`}/>
            <VideoComponent id="C01V306" src={process.env.PUBLIC_URL + `/videos/C01V306`}/>
            <VideoComponent id="S11V171" src={process.env.PUBLIC_URL + `/videos/S11V171.mp4`}/>
            <VideoComponent id="S12V179" src={process.env.PUBLIC_URL + `/videos/S12V179.mp4`}/>
            <VideoComponent id="S12V183" src={process.env.PUBLIC_URL + `/videos/S12V183.mp4`}/>
            <VideoComponent id="S12V189" src={process.env.PUBLIC_URL + `/videos/S12V189.mp4`}/>
            <VideoComponent id="S12V190" src={process.env.PUBLIC_URL + `/videos/S12V190.mp4`}/>
            <VideoComponent id="S12V191" src={process.env.PUBLIC_URL + `/videos/S12V191.mp4`}/>
            <VideoComponent id="S15V228" src={process.env.PUBLIC_URL + `/videos/S15V228.mp4`}/>
            <VideoComponent id="S15V229" src={process.env.PUBLIC_URL + `/videos/S15V229.mp4`}/>
            <VideoComponent id="S15V230" src={process.env.PUBLIC_URL + `/videos/S15V230.mp4`}/>
            <VideoComponent id="S15V231" src={process.env.PUBLIC_URL + `/videos/S15V231.mp4`}/>
            <VideoComponent id="S15V233" src={process.env.PUBLIC_URL + `/videos/S15V233.mp4`}/>
            <VideoComponent id="S15V234" src={process.env.PUBLIC_URL + `/videos/S15V234.mp4`}/>
            <VideoComponent id="S15V235" src={process.env.PUBLIC_URL + `/videos/S15V235.mp4`}/>
            <VideoComponent id="S15V236" src={process.env.PUBLIC_URL + `/videos/S15V236.mp4`}/>
            <VideoComponent id="S16V244" src={process.env.PUBLIC_URL + `/videos/S16V244.mp4`}/>
            <VideoComponent id="S17V272" src={process.env.PUBLIC_URL + `/videos/S17V272.mp4`}/>
            <VideoComponent id="S17V278" src={process.env.PUBLIC_URL + `/videos/S17V278.mp4`}/>

            <VideoComponent id="S11V344" src={process.env.PUBLIC_URL + `/videos/S11V344.mp4`}/>
            <VideoComponent id="S11V345" src={process.env.PUBLIC_URL + `/videos/S11V345.mp4`}/>
            <VideoComponent id="S11V347" src={process.env.PUBLIC_URL + `/videos/S11V347.mp4`}/>


            {/*/!*Audio*!/*/}
            {/*<VideoComponent id="ARCA01" src={process.env.PUBLIC_URL + `/audio/ARCA01.wav`} audio="Y"/>*/}
        </div>
    )
}

export default VideosComponent;